import { Component, EventEmitter, Input, Output } from '@angular/core';
import { translationKeys } from '../../../core';
import { TableColumnConfiguration } from '@avano/avano-components/avano-table';
import { DossierError } from '../../dialogs/dossier-error-details-dialog/dossier-error-details-dialog.component';
import { DossierDtoEchaResponseStatusEnum } from '@scip/api/index';

@Component({
  selector: 'scip-twin-table-select',
  templateUrl: './twin-table-select.component.html',
  styleUrls: ['./twin-table-select.component.scss']
})
export class TwinTableSelectComponent {
  @Input() tableColumnConfig: TableColumnConfiguration[];
  // Available organizations for the table on the left
  @Input() twinTableData: unknown[];
  @Input() loading: boolean;
  @Output() readonly emitSelectionData: EventEmitter<unknown[]> = new EventEmitter();
  selectionData: unknown[] = [];

  tableOneSelection: unknown[] = [];
  tableTwoSelection: unknown[] = [];

  showDossierErrorDetails = false;
  selectedDossierError: DossierError;

  translationKeys: typeof translationKeys = translationKeys;

  selectionLeftToRight(): void {
    for (const data of this.tableOneSelection) {
      if (!this.selectionData.includes(data, 0)) {
        this.selectionData.push(data);
        this.twinTableData.splice(this.twinTableData.indexOf(data), 1);
      }
    }
    this.handleTransfer();
  }

  allLeftToRight(): void {
    for (const data of this.twinTableData) {
      if (!this.selectionData.includes(data, 0)) {
        this.selectionData.push(data);
      }
    }
    this.twinTableData = [];
    this.handleTransfer();
  }

  selectionRightToLeft(): void {
    for (const data of this.tableTwoSelection) {
      let i = 0;
      for (const comp of this.selectionData) {
        if (data === comp) {
          this.selectionData.splice(i, 1);
          this.twinTableData.push(data);
        }
        i++;
      }
    }
    this.handleTransfer();
  }

  allRightToLeft(): void {
    for (const data of this.selectionData) {
      if (!this.twinTableData.includes(data, 0)) {
        this.twinTableData.push(data);
      }
    }
    this.selectionData = [];
    this.handleTransfer();
  }

  setTableOneSelection(newSelection): void {
    this.tableOneSelection = newSelection;
    this.tableTwoSelection = [];
  }

  setTableTwoSelection(newSelection): void {
    this.tableOneSelection = [];
    this.tableTwoSelection = newSelection;
  }

  private handleTransfer(): void {
    // To trigger primeNG changeDetection we need to update the references
    this.selectionData = [...this.selectionData];
    this.twinTableData = [...this.twinTableData];

    this.emitSelectionData.emit(this.selectionData);
    this.tableTwoSelection = [];
    this.tableOneSelection = [];
  }

  showErrorDetails(echaResponseStatus: DossierDtoEchaResponseStatusEnum, echaResponseErrorText: string): void {
    this.selectedDossierError = {
      echaResponseErrorText,
      echaResponseStatus
    };
    this.showDossierErrorDetails = true;
  }
}
